import {
  Input,SimpleChanges,OnChanges,
  Component,
  OnInit
} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {ImageVM} from "../../models/ImageVM.model";
import {CompanyVM} from "../../models/CompanyVM.model";
import {CompanyService} from "../../services/company-service/company-service";
import {CategoryVM} from "../../models/CategoryVM.model";
import {CategoryService} from "../../services/category/category.service";
import {ServiceItemDetailVM} from "../../models/ServiceItemDetailVM";



@Component({

  selector: 'rw-company-list',  // <home></home>

  styles: [require('./company-list.component.css')],

  template: require('./company-list.component.html')
})
export class CompanyListComponent implements OnInit,OnChanges {

  @Input() public company:CompanyVM;
 public companyList:CompanyVM[];
  public Cat1='BRANCH';
  public Cat2='AGENT';
  public Cat3='MEETING';
  public selectedCat='';
 public companyListCat1:CompanyVM[];
 public companyListCat2:CompanyVM[];
 public companyListCat3:CompanyVM[];
  public selectedCity=1;


  /**
   * TypeScript public modifiers
   */
  constructor(private activatedRoute:ActivatedRoute, private companyService:CompanyService, private categoryService:CategoryService) {
  }



  public ngOnInit() {


  }

  setCategory(category):void
  {
    this.selectedCat=category;
  }
  ngOnChanges(changes:SimpleChanges):void {
    let parent=this;
if(this.company)
{

}


  }
  updateCompanyList(e){
    let parent=this;
    this.selectedCat='';

  let parentid=  e.value+""+this.company.id;
    this.companyService.getCompanyListByParent(parentid).subscribe(function(companies){
     if( companies ) {

       parent.companyList = companies.sort((c1,c2)=>{
        let n1=c1.title.trim();
        let n2=c2.title.trim();
         if(n1>n2)return 1;
         if(n2>n1)return -1;
         return 0;


       });
       parent.companyListCat1=[];
       parent.companyListCat2=[];
       parent.companyListCat3=[];

       parent.companyList.forEach(function(company){
         if(company.category==parent.Cat1)
         {
           parent.companyListCat1.push(company);
         }
         if(company.category==parent.Cat2)
         {
           parent.companyListCat2.push(company);
         }
         if(company.category==parent.Cat3)
         {
           parent.companyListCat3.push(company);
         }

       })
     }
    })
  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/company-list/company-list.component.ts